import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Stack,
  Chip,
  IconButton,
  Grid,
  Divider,
  Menu,
  MenuItem,
  Tooltip,
  Modal
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Card from "../../../components/ui/Card";
import { formatDate } from "../../../utils/dateFormatUtils";
import { RowData } from "../../../pages/dashboard/termLoan/RequestForDisbursementTerm";
import {
  formatIndianRupees,
  formatNormalIndianRupees,
  toPascalCase
} from "../../../utils/formatting";
import InfoIcon from "../../../assets/images/icons/info.png";
import ModelViewForMobile from "../../ui/ModelViewForMobile";
import { styled } from "@mui/material/styles";
import { set } from "react-hook-form";

interface Item {
  accountNumber: string;
  status: string;
  initiatedBy: string;
  requested: string;
  disbursed: string;
  amount: string;
  referenceNumber: string;
  initatedBy: string;
  trancheAmount: number;
  requestedDate: string;
  disbursemntDate: string;
}

interface CardItemListProps {
  testData: RowData[];
  onActionClick: (rowData: RowData) => void;
}

const ItemCard = ({
  item,
  onActionClick,
}: {
  item: RowData;
  onActionClick: (rowData: RowData) => void;
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [openModal,setOpenModal]=useState<boolean>(false);
  const [openModalNew,setOpenModalNew]=useState<boolean>(false);
  const [openModalNewDate,setOpenModalNewDate]=useState<boolean>(false);
  const [rowsData,setRowsData]=useState<any>(null);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    onActionClick(item);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleCloseModalNew=(val:boolean)=>{
    if(val){
      setRowsData(item);
    }
    setOpenModalNew(val);
  }
  const handleToolTip = (row: any,type?:any) => {
    
    return (
      <>
        {/* <Tooltip
          title={type?type:`${row?.remark}`}
          enterTouchDelay={50}
          placement="top"
        > */}
          <img
            src={InfoIcon}
            alt="Status"
            style={{
              height: "15px",
              width: "15px",
              marginLeft: "5px",
              position: "relative",
              top: "4px",
            }}
            onClick={() => handleCloseModalNew(true)}
          />
        {/* </Tooltip> */}
      </>
    )
  }
  const handleCloseModal = (type:boolean) => {
    setOpenModal(type);
  };
  const StatusBadge = styled("span")<{
    statusColor: string;
    backgroundColor: string;
  }>(({ statusColor, backgroundColor }) => ({
    color: statusColor,
    textTransform: "capitalize",
    textAlign: "left",
    backgroundColor,
    width: "110px",
    padding: "4px 1px",
    borderRadius: "4px",
    fontSize: "14px",
    fontWeight: 500,
    border: "none",
    display: "inline-block",
  }));
  const handleViewStatusModal = (row: any) => {
    setOpenModal(true);
    setRowsData(row);
  }
  const modalStyle=
         {
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            bgcolor: "background.paper",
            borderTopLeftRadius: "16px",
            borderTopRightRadius: "16px",
            boxShadow: "0px -2px 10px rgba(0,0,0,0.2)",
            maxHeight: "85vh",
            overflowY: "auto",
            p: 2,
          }
    const Card = styled(Box)(() => ({
      border: "1px solid #E0E0E0",
      borderRadius: "8px",
      backgroundColor: "#fff",
      boxShadow: "0px 1px 4px rgba(0,0,0,0.1)",
    }));
  return (
    <>
      <Box mb={2} mt={1} ml={0}>
        <Card>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="subtitle1" fontWeight="bold" sx={{marginLeft:"5px"}}>
              {String(item?.referenceNumber)}
            </Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                textTransform: "capitalize",
              }}
            >
              <Chip
                 label={
                    Array.isArray(item?.lienValues) && item.lienValues.length > 0 ?
                      <StatusBadge
                        statusColor="#EA5455"
                        backgroundColor=""
                        onClick={() => handleViewStatusModal(item)}
                        style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
                      >
                        <span
                          style={{
                            cursor: "pointer",
                            textDecoration: "underline",
                            color: "blue",
                            textAlign: "center",
                            width: "100%",
                            display: "block"
                          }}
                        >
                          {"View Status"}
                        </span>
                      </StatusBadge>:
                      item.status === "approve" || item.status === "approved"
                      ? "approved"
                      :item.status === "pending" || item.status === "Pending"
                      ? <>{"pending"} {handleToolTip(item)} </>
                      : item.status === "reject" || item.status === "rejected" || item.status === "cancelled"
                        ? (<>{item.status === "reject" || item.status === "rejected" ? "Rejected" : "Cancelled"} {" "} {handleToolTip(item)} </>)
                        : item.status
                  }
                sx={{
                  marginRight: "0px",
                  // Conditional styling based on status
                  ...(
                    Array.isArray(item?.lienValues) && item.lienValues.length > 0 ?
                    {
                      color:"blue",
                      backgroundColor:"rgba(153, 169, 241, 0.2)"
                    }
                    :
                    item.status === "reject" || item.status === "Failed" || item.status === "cancelled"
                    ? {
                      color: "#EA5455",
                      backgroundColor: "rgba(234, 84, 85, 0.2)",
                    }
                    : item.status === "indraft"
                      ? {
                        color: "#1CB1B1",
                        backgroundColor: "rgba(225, 219, 253, 0.2)",
                      }
                      : item.status === "query"
                        ? {
                          color: "#1CB1B1",
                          backgroundColor: "rgba(225, 219, 253, 0.2)",
                        }
                        : item.status === "approve" || item.status === "Success"
                          ? {
                            color: "#28C76F",
                            backgroundColor: "rgba(40, 199, 111, 0.2)",
                          }
                          : item.status === "pendingFromAvanse"
                            ? {
                              color: "#EF7327",
                              backgroundColor: "rgba(243, 111, 33, 0.2)",
                            }:  {
                              // Default styling
                              background: "#fde2d3",
                              color: "#ff9f43",
                            }),
                }}
                //onClick={item.status === "reject" ? () => handleCloseModal(true) : undefined}
              />
              <IconButton
                aria-label="more"
                id="long-button"
                aria-controls={open ? "long-menu" : undefined}
                aria-expanded={open ? "true" : undefined}
                aria-haspopup="true"
                onClick={handleClick}
              >
                <MoreVertIcon />
              </IconButton>
              <Menu
                id="long-menu"
                MenuListProps={{
                  "aria-labelledby": "long-button",
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
              >
                {/* Add your menu items here */}
                <MenuItem onClick={handleClose}>Option 1</MenuItem>
                <MenuItem onClick={handleClose}>Option 2</MenuItem>
              </Menu>
            </Box>
          </Stack>
          <Divider />
          <Grid container mt={1} className="dashboard-container" ml={1} mb={1}>
            <Grid item xs={3} sm={3}>
              <Typography className="insidePageLable">Initiated By</Typography>
              <Typography
                className="insidePageValue"
                style={{ padding: "0px", marginTop: "3px" }}
              >
                {item.initatedBy}
              </Typography>
            </Grid>
            <Grid item xs={6} sm={6}>
              <Grid container>
                <Grid item xs={12} sm={12}>
                  <Typography className="insidePageLable">
                    Requested{" "}
                    <span className="insidePageValue">
                      {formatDate(String(item?.requestedDate || ""))}
                    </span>
                  </Typography>
                  <p className="insidePageLable" style={{ marginTop: "-5px" }}>
                    Disbursement{" "}
                    <span className="insidePageValue">
                        {Array.isArray(item?.lienValues) && item?.lienValues?.length > 1 && item?.lienValues?.filter((v) => v?.disbDate !== null && v?.disbDate !== "").length > 0 ? (
                          // More than one dataset - show info icon
                          <img
                            src={InfoIcon}
                            alt="Status"
                            style={{
                              height: "15px",
                              width: "15px",
                              marginLeft: "5px",
                              position: "relative",
                              top: "4px",
                            }}
                            onClick={() => {
                              setOpenModalNewDate(true);
                              setRowsData(item);
                            }}
                          />
                        ) : Array.isArray(item?.lienValues) && item?.lienValues?.length === 1 ? (
                          // Use filter without else
                          (() => {
                            const lienData = item?.lienValues?.filter(
                              (v) => v?.type?.toLowerCase() === "lien"
                            );

                            // Only return lien date — no fallback
                            return lienData.length > 0
                              ? formatDate(String(lienData[0]?.disbDate) || "")
                              : formatDate(String(item?.disbursemntDate) || "");
                          })()
                        ) : (
                          formatDate(String(item?.disbursemntDate) || "")
                        )}
                    </span>
                  </p>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={2} sm={3}>
              <Typography className="insidePageLable">Requested Amount</Typography>
              <Typography
                className="insidePageValue"
                style={{ padding: "0px", marginTop: "3px" }}
              >
                {item?.trancheAmount ? (
                  <>
                    {item?.currencyCode} {item?.trancheAmount}
                  </>
                ) : (
                  "-"
                )}
                {/* {item.status == "approve" && (
                  <Tooltip
                    title={`Disbursement Amount = INR ${item?.disbursedAmount}`}
                    enterTouchDelay={50}
                    placement="top"
                  >
                    <img
                      src={InfoIcon}
                      alt="Status"
                      style={{
                        height: "15px",
                        width: "15px",
                        marginLeft: "5px",
                        position: "relative",
                        top: "4px",
                      }}
                    />
                  </Tooltip>
                )} */}
              </Typography>
            </Grid>
          </Grid>
        </Card>
      </Box>
      <ModelViewForMobile rows={rowsData} onCloseFun={() => handleCloseModal(false)} openModal={openModal}/>
      <Modal open={openModalNew} onClose={()=>handleCloseModalNew(false)}>
          <Box sx={modalStyle}>
            {/* Content */}
            <Grid container spacing={2}>
              <Grid item xs={12} sm={9}>
                <Box
                  sx={{
                    borderBottom: "none",
                    pb: 2,
                    mb: 2,
                  }}
                >
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <Typography sx={{fontWeight:"bold",fontSize:"16px"}}>
                        {toPascalCase(rowsData?.status)}
                      </Typography>
                      <Typography variant="caption">
                        {rowsData?.status.toLowerCase() ==="pending"?"Pending From Avanse":rowsData?.remark}
                      </Typography>
                      <Typography fontWeight={600}>
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
            {/* Close button */}
            <Box mt={2} textAlign="center">
              <Box
                component="button"
                onClick={()=>handleCloseModalNew(false)}
                style={{
                  backgroundColor: "#00B8A9",
                  color: "#fff",
                  border: "none",
                  borderRadius: "8px",
                  padding: "12px 20px",
                  cursor: "pointer",
                  width: "100%",
                  fontWeight: 600,
                }}
              >
                Close
              </Box>
            </Box>
          </Box>
      </Modal>
      <Modal open={openModalNewDate} onClose={()=>{setOpenModalNewDate(false)}}>
          <Box sx={modalStyle}>
            {/* Content */}
            <Grid container spacing={2}>
              <Grid item xs={12} sm={9}>
                <Box
                  sx={{
                    borderBottom: "none",
                    pb: 2,
                    mb: 2,
                  }}
                >
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <Typography variant="body2" sx={{ mt: 1 }}>
                          <strong>Lien Disbursement Date:</strong>{" "}
                          {Array.isArray(rowsData?.lienValues)
                          ? (
                            rowsData.lienValues.find(
                              (v: any) =>
                              v.type?.toLowerCase() === "lien"
                            )?.disbDate
                            )
                            ? formatDate(
                              rowsData.lienValues.find(
                              (v: any) =>
                                v.type?.toLowerCase() === "lien"
                              )?.disbDate
                            )
                            : "-"
                          : "-"}
                        </Typography>
                        <Typography variant="body2" sx={{ mt: 1 }}>
                          <strong>Tranche Disbursement Date:</strong>{" "}
                          {Array.isArray(rowsData?.lienValues)
                          ? (
                            rowsData?.disbursemntDate
                            )
                            ? formatDate(
                              String(rowsData?.disbursemntDate)
                            )
                            : "-"
                          : "-"}
                        </Typography>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
            {/* Close button */}
            <Box mt={2} textAlign="center">
              <Box
                component="button"
                onClick={()=>setOpenModalNewDate(false)}
                style={{
                  backgroundColor: "#00B8A9",
                  color: "#fff",
                  border: "none",
                  borderRadius: "8px",
                  padding: "12px 20px",
                  cursor: "pointer",
                  width: "100%",
                  fontWeight: 600,
                }}
              >
                Close
              </Box>
            </Box>
          </Box>
      </Modal>
    </>
    
  );
};

function CardItemList({ testData, onActionClick }: CardItemListProps) {
  const [responseReceived, setResponseReceived] = useState(false);

  useEffect(() => {
    // Simulating an API call with a timeout
    const fetchData = () => {
      // Replace this timeout with actual API call
      setTimeout(() => {
        setResponseReceived(true);
      }, 1000);
    };

    fetchData();
  }, []);

  return (
    <>
    <div>
      {responseReceived ? (
        testData.length === 0 ? (
          <Typography variant="h6" align="center" className="no-records-found">
            No records found
          </Typography>
        ) : (
          testData.map((item: RowData) => (
            <ItemCard
              key={item.accountNumber}
              item={item}
              onActionClick={onActionClick}
            />
          ))
        )
      ) : (
        <Typography variant="h6" align="center" className="no-records-found">
          Loading...
        </Typography>
      )}
    </div>
    </>
  );
}

export default CardItemList;
